import { render, staticRenderFns } from "./Navegation.vue?vue&type=template&id=580bf1b6&"
import script from "./Navegation.vue?vue&type=script&lang=js&"
export * from "./Navegation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports